import React from 'react';

import { useBreakpointValue } from 'native-base';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { primitive, spacing } from 'styles/constants';

export const ProductSkeletonCardWrapper = ({ style, ...props }: BoxProps) => {
  const backgroundColor = useBreakpointValue({
    base: primitive.$blackOpacity4,
    md: 'transparent',
  });

  return React.createElement(Box, {
    ...props,
    style: [styles.productSkeletonCardWrapper, { backgroundColor }, style],
  });
};

export const ProductSkeletonCardContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.productSkeletonCardContainer, style],
  });

export const ProductSkeletonCards = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.productSkeletonCards, style],
  });

export const SkeletonCard = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.skeletonCard, style],
  });

export const SkeletonCardContent = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.skeletonCardContent, style],
  });

const styles = StyleSheet.create({
  productSkeletonCardContainer: {
    paddingTop: spacing.$4,
    width: '100%',
  },
  productSkeletonCardWrapper: {
    width: '100%',
  },
  productSkeletonCards: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    marginVertical: spacing.$2,
    width: '100%',
  },
  skeletonCard: {
    flex: 1,
    height: 160,
    padding: spacing.$2,
  },
  skeletonCardContent: {
    backgroundColor: primitive.$white,
    borderColor: primitive.$blackOpacity10,
    borderRadius: primitive.$borderRadius,
    borderWidth: 2,
    flex: 1,
    padding: spacing.$2,
  },
});
